module.exports = __webpack_public_path__ + "img/website.e8334604.svg";